import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useToastContext } from "components/alert/ToastContext";
import Indicador from "model/indicadores/Indicador";
import { IndicadorColeta } from "model/indicadores/IndicadorColeta";
import IndicadorDashboardItem from "model/indicadores/IndicadorDashboardItem";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable, DataTableRowEditCompleteEvent } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useState } from "react";
import IndicadorColetaService from "service/indicadores/IndicadorColetaService";
import IndicadorService from "service/indicadores/IndicadorService";
import { converterData } from "utils/convert";

interface ModalColetaIndicadorProps {
    visible: boolean;
    onHide: () => void;
    indicadorId: number;
}

const indicadorColetaService = new IndicadorColetaService();
const indicadorService = new IndicadorService();
export default function ModalColetaIndicador(props: ModalColetaIndicadorProps) {
    const { msgSucesso, msgErro, msgAlerta } = useToastContext();
    const { startLoading, stopLoading } = useLoadingContext();
    const [indicador, setIndicador] = useState<Indicador | null>(null);

    useEffect(() => {
        startLoading();
        indicadorColetaService.buscarPorIndicador(props.indicadorId).then(resposta => {
            setIndicador(resposta);
            stopLoading();
        }).catch(error => {
            console.error(error);
            stopLoading();
        })
    }, [])

    function novaColeta() {
        startLoading();
        if (indicador?.itens.some(c => !c.coleta?.id)) {
            msgAlerta('Indicador Coleta', 'Você precisa salvar o último registro para adicionar um novo.');
            stopLoading();
            return;
        }

        indicadorColetaService.prepararProximaColeta(props.indicadorId).then(resposta => {
            if (resposta.coleta) {
                resposta.coleta.alterado = true;
            }
            if (indicador) {
                indicador.itens.unshift(resposta);
                setIndicador({ ...indicador });
            }
            stopLoading();
        }).catch(error => {
            console.error(error);
            stopLoading();
        })
    }

    function salvarColeta(coleta: IndicadorColeta, index: number) {
        startLoading();
        const serviceCall = coleta.id
            ? indicadorColetaService.editar(coleta)
            : indicadorColetaService.incluir(coleta);

        serviceCall
            .then(resposta => {
                const atualizadas = [...indicador?.itens || []];
                atualizadas[index].coleta = resposta;
                setIndicador({ ...indicador, itens: atualizadas } as Indicador);
                msgSucesso('Indicador Coleta', 'Registro gravado com sucesso');
                stopLoading();
            })
            .catch(error => {
                console.error(error);
                if (error && error.data && error.data.message) {
                    msgErro('Indicador Coleta', error.data.message);
                } else {
                    msgErro('Indicador Coleta', 'Ocorreu um erro ao tentar gravar, tente novamente!');
                }
                stopLoading();
            });
    }

    return (
        <>
            <Dialog visible={props.visible} style={{ width: '65vw', minHeight: "50vh" }} modal onHide={props.onHide}
                header="Indicador Coletas">
                <DataTable emptyMessage="Nenhum registro encontrado"
                    value={indicador?.itens || []}
                    header={<div style={{ display: "flex", justifyContent: "space-between", textAlign: 'center', alignContent: "center" }}>
                        <div></div>
                        <span style={{ textAlign: 'center', alignSelf: "center", position: 'relative' }}>Coletas</span>
                        <div>
                            <Button
                                type="button" icon={<FontAwesomeIcon icon="add" />}
                                tooltip="Adicionar"
                                tooltipOptions={{ position: "top" }} className="ui-button-info" onClick={() => novaColeta()}
                            ></Button>
                        </div>
                    </div>}
                >
                    <Column field="coleta.dataColeta" header="Data Coleta" body={(rowData: IndicadorDashboardItem) => converterData(rowData.coleta?.dataColeta)} />
                    <Column field="coleta.usuarioColeta.nome" header="Usuário Coleta" />
                    <Column header="Meta" body={(rowData: IndicadorDashboardItem) => {
                        return rowData.meta ? `${indicadorService.getTipoMeta(rowData.meta.tipo||"").simbolo} ${rowData.meta.meta || 0}` : "-";
                    }} />
                    <Column field="coleta.valorColeta" header="Valor" body={(rowData: IndicadorDashboardItem) => <InputNumber
                        locale="pt-BR"
                        value={rowData.coleta?.valorColeta}
                        style={{ width: '100%' }}
                        onChange={(e) => {
                            if (rowData.coleta && indicador) {
                                rowData.coleta.alterado = true;
                                rowData.coleta.valorColeta = e.value;
                                setIndicador({ ...indicador });
                            }
                        }}
                    />} />
                    <Column field="coleta.observacao" header="Observação" body={(rowData: IndicadorDashboardItem) => <InputText
                        value={rowData.coleta?.observacao||""}
                        style={{ width: '100%' }}
                        onChange={(e) => {
                            if (rowData.coleta && indicador) {
                                rowData.coleta.alterado = true;
                                rowData.coleta.observacao = e.target.value;
                                setIndicador({ ...indicador });
                            }
                        }}
                    />} />
                    <Column
                        body={(rowData: IndicadorDashboardItem, options) => (
                            <Button
                                disabled={!rowData.coleta?.alterado}
                                icon="pi pi-check"
                                onClick={() => salvarColeta(rowData?.coleta as IndicadorColeta, options.rowIndex)}
                            />
                        )}
                    />
                </DataTable>
            </Dialog>
        </>
    )
}